import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  LinearProgress,
  Modal,
} from '@mui/material';
import { MaterialReactTable } from 'material-react-table';
import Avatar from '@mui/material/Avatar';
import DeleteIcon from '@mui/icons-material/Delete';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import { InputAdornment } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import AddOrganizationModal from './AddOrganizationModal';
import EditOrganizationModal from './EditOrganizationModal';
import LeadService from '../../core/services/leadsService';
import LogoutExpiredModal from '../../components/LogoutExpiredModal';
import toast from 'react-hot-toast';
import { format } from 'date-fns';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import { GlobalStyles } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
const useStyles = makeStyles((theme) => ({
  LeadTable: {
    overflowX: 'auto',
    width: 'auto',
    borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
  },

}));
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: '#fff',
  padding: '20px',
  borderRadius: '10px',
  width: '558px',
  height: 'auto',
  overflow: 'auto',

}
const OrganizationCustomer = () => {
  const [allOrganization, setAllOrganization] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [deleteId, setDeleteId] = useState('');
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [getCurrentId, setGetCurrentId] = useState('');
  const [logOutModal, setLogOutModal] = useState(false);
  const classes = useStyles();
  const theme = useTheme();
  const handleClose = () => {
    setOpen(false);
    setDeleteId(null)
  }

  const handleOpenDelete = (id) => {
    setDeleteId(id);
    setOpen(true);
  }

  const handleGetId = (id) => {
    setGetCurrentId(id);
  }

  const GetAllOrganization = async () => {
    try {
      setLoading(true);
      const res = await LeadService.getAllOrganization();
      if (res?.data?.success) {
        setAllOrganization(res?.data?.data)
        return;
      }
    } catch (error) {
      if (error.message === 'You have been logged out of the application, please login again to use the application.') {
        setLogOutModal(true);
      } else {
        toast.error(error.message);
      }
    } finally {
      setIsLoading(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    GetAllOrganization();
  }, []);

  const HandleDeleteId = async (deleteId) => {
    try {
      setOpen(false);
      const res = await LeadService.getDeletedOrganization(deleteId)
      if (res?.data?.success) {
        toast.success(res?.data?.message);
        setOpen(false);
        GetAllOrganization();
      }
    } catch (error) {
      toast.error(error.message);
    }
  }

  const adjustTimeBasedOnOffsetForReceivedData = (dateString, offsetInHours) => {
    // Create a date object from the UTC date string
    const date = new Date(dateString);

    // Ensure the date is in UTC by setting the time zone offset
    // Convert date to milliseconds and then adjust by the user offset
    const utcDate = new Date(date.getTime() + (date.getTimezoneOffset() * 60000));

    // Apply the user offset
    utcDate.setHours(utcDate.getHours() + offsetInHours);

    return utcDate;
  };

  const getUserOffset = () => {
    const offset = localStorage.getItem('userOffset');
    return offset ? parseFloat(offset) : 0;
  };

  const formatDateTime = (date) => {
    const options = { year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
    return date.toLocaleDateString(undefined, options).replace(',', '');
  };

  const columns = [
    {
      accessorKey: 'id',
      header: 'Sr no',
      size: 50,
      muiTableHeadCellProps: {
        sx: {
          fontSize: '14px',
        },
      },
    },
    {
      accessorKey: 'organization_name',
      header: 'Organization Name',
      Cell: ({ row }) => (
        <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
          <div>
            <Avatar src={`https://iconnctapp.com/` + row?.original?.profile_image} />
          </div>
          <div style={{ marginTop: '10px' }}>
            <span style={{ marginLeft: 10 }}>{row?.original?.organization_name}</span>
          </div>
        </div>
      ),
      enableColumnActions: false,
      showColumnFilters: false,
      enableColumnFilter: false,
      enableSorting: false,
      size: 200,
      muiTableHeadCellProps: {
        align: 'center',
      },
    },
    {
      accessorKey: 'email',
      header: 'Organization Email',
      enableColumnActions: false,
      showColumnFilters: false,
      enableColumnFilter: false,
      enableSorting: false,
      muiTableHeadCellProps: {
        sx: {
          fontSize: '14px',
        },
      },
      size: 'auto',
    },

    {
      accessorKey: 'phone',
      header: 'Phone Number ',
      enableColumnActions: false,
      showColumnFilters: false,
      enableColumnFilter: false,
      enableSorting: false,
      muiTableHeadCellProps: {
        sx: {
          fontSize: '14px',
        },
      },
      size: 'auto',
    },

    {
      accessorKey: 'created_at',
      header: 'Organization Since',
      enableColumnActions: false,
      showColumnFilters: false,
      enableColumnFilter: false,
      enableSorting: false,
      size: 50,
      muiTableHeadCellProps: {
        sx: {
          fontSize: '14px',
        },
      },
      Cell: ({ row }) => {
        const dateString = row?.original?.created_at;

        if (dateString) {
          const userOffset = getUserOffset();
          const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
          return <span>{formatDateTime(adjustedDate)}</span>;
        }
        return null;
      },
    },
    {
      accessorKey: 'organization_code',
      header: 'Organization Code',
      enableColumnActions: false,
      showColumnFilters: false,
      enableColumnFilter: false,
      enableSorting: false,
      muiTableHeadCellProps: {
        sx: {
          fontSize: '14px',
        },
      },
      size: 'auto',
    },

    {
      id: 'actions',
      accessorKey: 'SeeMore',
      header: 'Action',
      enableColumnActions: false,
      showColumnFilters: false,
      enableColumnFilter: false,
      size: 80,
      muiTableHeadCellProps: {
        align: 'center'
        , sx: {
          fontSize: '14px',
        },
      },
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

            <IconButton aria-label="edit"
              onClick={() => handleGetId(row?.original?.id)}
            >
              <EditOrganizationModal
                updatedId={getCurrentId}
                GetAllOrganization={GetAllOrganization}
                UserId={row?.original?.id}
                image={row?.original?.profile_image}
                OrgName={row?.original?.organization_name}
                phone={row?.original?.phone}
                email={row?.original?.email}
              />

            </IconButton>
            {/* <IconButton
              aria-label="delete">
              <DeleteIcon
                onClick={() => handleOpenDelete(row?.original?.id)}
                sx={{ color: '#E71D36' }} />
            </IconButton> */}
          </div>
        );
      },
    }
  ]

  return (
    <div>
      <div style={{ marginBottom: '15px' }}> {loading && <LinearProgress />}</div>
      <Box style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>

        <AddOrganizationModal
          GetAllOrganization={GetAllOrganization}
        />

        {/* <TextField
          placeholder="Search"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton  aria-label="clear search">
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          variant="outlined"
          style={{ width: '276px',  }}
        /> */}

      </Box>
      <>
        <ThemeProvider theme={theme}>
          <GlobalStyles
            styles={{
              '::-webkit-scrollbar': {
                width: '14px', // Set the desired width for the scrollbar
              },
              '::-webkit-scrollbar-thumb': {
                backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                borderRadius: '10px', // Set the border radius for a rounded effect
              },
            }}
          />
          <div style={{ marginTop: '10px', }} className={classes.LeadTable}>
            <MaterialReactTable
              columns={columns}
              data={allOrganization}
              state={{ isLoading: isLoading }}
              muiCircularProgressProps={{
                color: 'secondary',
                thickness: 5,
                size: 55,
              }}
              muiSkeletonProps={{
                animation: 'pulse',
                height: 28,
              }}
              enableTopToolbar={false}
              enableFacetedValues={true}
              enableDensityToggle={false}
              enableHiding={false}
              showSkeletons={false}
              enableStickyHeader={true}
              enableColumnFilterModes={false}
              enableColumnActions={false}
              enableColumnOrdering={false}
              enableFullScreenToggle={false}
              enableColumnFilters={false}
              enablePagination={false}
              initialState={{
                showColumnFilters: false,
                showGlobalFilter: false,
              }}
              muiTableBodyRowProps={{
                sx: {
                  backgroundColor: '#f5f5f5', // Default row background color
                  '&:nth-of-type(odd)': {
                    backgroundColor: '#ffffff', // Alternate rows with white
                  },
                  '&:hover': {
                    backgroundColor: '#e0e0e0', // Hover effect
                    cursor:'pointer'
                  },
                },
              }}

            />
          </div>
        </ThemeProvider>
      </>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ marginTop: '20px', position: 'relative' }}>
            <Box sx={{
              display: 'grid',
              padding: '10px',
              gap: '10px',
            }}>
              <Box style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                <Box>
                  <DeleteIcon style={{ fontSize: '34px' }} />
                </Box>
                <Box style={{ display: 'grid', gap: '10px' }}>
                  <div>
                    <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Are you sure you want to delete this Organization?</span>
                  </div>
                  <div>
                    <span style={{ fontSize: '16px', color: '#252F46' }}>This action will delete this Organization permanently, and you can not undo this.</span>
                  </div>
                </Box>
              </Box>
            </Box>

            <Box style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
              <Button
                onClick={handleClose}
                style={{
                  width: '140px',
                  height: '43px',
                  backgroundColor: 'white',
                  fontWeight: '500',
                  borderRadius: '4px',
                  border: ' 1px solid #587DBF',
                  color: '#252F46',
                  fontSize: '15px',
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={() => HandleDeleteId(deleteId)}
                style={{
                  width: '140px',
                  height: '43px',
                  backgroundColor: '#5379BD',
                  fontWeight: '500',
                  borderRadius: '4px',
                  border: ' 1px solid #587DBF',
                  color: 'white',
                  fontSize: '15px',
                }}
              >
                Delete
              </Button>
            </Box>
          </div>
        </Box>
      </Modal>
      <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal} />
    </div>
  )
}

export default OrganizationCustomer